import {Component,OnInit,Output,EventEmitter,Input} from '@angular/core';
import {FormGroup, AbstractControl, FormBuilder, Validators} from '@angular/forms';

import 'style-loader!./login.scss';
import {Router,ActivatedRoute} from '@angular/router';
import {AuthService} from '../../common/services/permission';
import {LoginService} from './loginService.service';
import {Http} from '@angular/http';
//import {getmac} from 'getmac';
@Component({
  selector: 'login',
  templateUrl: './login.html',
  providers:[Http]
})
export class Login implements OnInit {
  @Output('signedIn') signedIn = new EventEmitter();
  @Input('toUrl')
  set toUrl(value:string){
    this._toUrl=value;
    //console.log(value);
  }
  private _toUrl:string ='';
  public form:FormGroup;
  public email:AbstractControl;
  public password:AbstractControl;
  public submitted:boolean = false;
  returnUrl: string;
  signOut;
  constructor(fb:FormBuilder,private route:ActivatedRoute,private router:Router,private loginService: LoginService ) {
    this.form = fb.group({
      'email': ['', Validators.compose([Validators.required, Validators.minLength(2)])],
      'password': ['', Validators.compose([Validators.required, Validators.minLength(4)])]
    });

    this.email = this.form.controls['email'];
    this.password = this.form.controls['password'];
  }
ngOnInit(){
  //console.log("login");
  let logout =this.route.snapshot.params['logout'];
  //console.log(logout);
 this.returnUrl = this.route.snapshot.params['returnUrl'] || '/';
 //console.log({retUrl1:this.returnUrl});
 
 if(logout){
   //console.log("log out");
   //this.onLogOut();
 }
 //console.log(this.returnUrl);
}
  public onSubmit(values:Object):void {
    this.submitted = true;
    //console.log({valid:this.form.valid,url:this.returnUrl});
    if (this.form.valid) {
      //console.log(this.email.value,this.password.value);
      this.loginService.login(this.email.value,this.password.value)
          .subscribe(
            data=>{
              //console.log(this.returnUrl + "/pages/dashboard");
              if(this._toUrl !=''){
                this.signedIn.emit("logged In");
              }
              else{
                this.router.navigate([this.returnUrl]);
              }
            }
          )
    }
  }

  public onLogOut():void{
    this.loginService.logout();
  }
}
